import { Stack, Typography } from "@mui/material";

export const SummaryChip = ({
  label,
  value,
  color,
}: {
  label: string;
  value: number | string;
  color?: string;
}) => (
  <Stack alignItems="center">
    <Typography
      variant="h6"
      fontWeight="fontWeightBold"
      color={color ?? "text.primary"}
    >
      {value}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
  </Stack>
);
